import { branding } from '@/config/branding'
import { useOrgBrandMark } from '@/hooks/useOrgBrandMark'
import { useCurrentOrganizationIdFromState } from '@/stores/authStore'
import { CheckCircle } from 'lucide-react'
import Logo from './ui/Logo'
import { OrgBrandMark } from './ui/OrgBrandMark'

export function FeaturesInfoPanel() {
	const brandMark = useOrgBrandMark(useCurrentOrganizationIdFromState())

	const features = [
		'Real-time monitoring',
		'Secure OTA updates',
		'Advanced analytics',
		'Custom Alerts and Notifications',
		'Mobile-device communication',
		'Built-in DBC parsing',
	]

	return (
		<div className='relative hidden md:block border-r border-border'>
			<div className='relative z-10 p-6'>
				{brandMark ? (
					<OrgBrandMark
						mark={brandMark}
						className='size-12 rounded-xl'
						alt='Organization brand mark'
						data-testid='organization-brand-logo'
					/>
				) : (
					<Logo height={40} />
				)}
				<h2 className='text-form-modal-title font-bold mb-2' data-testid='brand-marketing-headline'>
					{branding.marketingHeadline}
				</h2>
				<p className='text-control text-foreground/70' data-testid='brand-description'>
					{branding.description}
				</p>

				<ul className='mt-6 space-y-3 text-control font-bold'>
					{features.map(feature => (
						<li key={feature} className='flex items-center space-x-2 text-foreground/90'>
							<CheckCircle className='size-4 text-icon-success' />
							<span>{feature}</span>
						</li>
					))}
				</ul>
			</div>
		</div>
	)
}
